$(document).on('ready', function () {
  var width = $(window).width();
  $(".index-collection1").slick({
    slidesToShow: width <= 768 ? 2 : 4,
    slidesToScroll: 4,
    arrows: true,
  });
  $(".hot-ranking-product").slick({
    slidesToShow: width <= 768 ? 2 : 4,
    slidesToScroll: 4,
    arrows: true,
  });
  $('.z-bottom_tu').slick({
    infinite: true,
    slidesToShow: width <= 768 ? 2 : 5.2,
    slidesToScroll:1,
    arrows: true,
  });
  $('.s-bottom_tu').slick({
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
  });
  // product-template
  // $(".product-single__photos").slick({
  //     arrows: width <=768 ? false : true,
  // })
  //  if(width>749){
  //      $('.product-help>a').click(function(){
  //          $('#myTab>li:nth-child(3)').addClass('active').siblings().removeClass('active');
  //          $('#question').show().siblings().hide();
  //          $('html,body').animate({scrollTop:$('#myTab').offset().top-200}, 800);
  //      })
  //  }else{
  //  $('.product-help>a').click(function(){
  //      console.log(111);
  //      $('.description-tab-ul>li:nth-child(1)').addClass('on').siblings().removeClass('on');
  //      $('.description-tab-ul>li:nth-child(1)').children('.descriptions').show();
  //      $('html,body').animate({scrollTop:$('#porduct-table-cm').offset().top-50}, 800);
  //  })
  //  }
  $('.product-help>a').click(function () {
    $('.help_tc_mian').show();
  })
  $('.help_tc_mian,.hele_tc-colse').click(function (e) {
    $('.help_tc_mian').hide()
  });
  $('.help_tc_center').click(function () {
    return false;
  })
  $('.slick-like ').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: width <= 749 ? false : true,
    responsive: [{
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, ]
  });
  //   $(".swiper-container").slick()
  var slickimgs = $('.slick-slides').length;
  console.log(slickimgs)
  $('.click-top').slick({
    slidesToShow: 4,
    rows: 6,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    infinite: true,
    swipe: true,
    infinite: true,
    arrows: true,
    vertical: width <= 768 ? false : true,
    verticalSwiping: width <= 768 ? false : true,
    asNavFor: '.click-bottom',
  });
  $('.click-bottom').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    infinite: true,
    dots: width <= 768 ? false : true,
    arrows: false,
    asNavFor: '.click-top',
  });
  if (width > 749) {
    $('.custom-content-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
    });
  } else {
    $('.custom-content-main').slick({
      slidesToShow: 1.2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      vertical: true,
    });
  }
  $(".detial-tit").click(function () {
    $(this).siblings().slideToggle();
    if ($(this).parent().hasClass("on")) {
      $(this).parent().removeClass("on")
    } else {
      $(this).parent().addClass("on")
    }
  })
  $(document).delegate(".product-number-add", 'click', function () {
    var now = $(this),
      _input = now.siblings(".js-quantity-selector");
    num = parseInt(_input.val()) + 1;
    _input.val(num);
  }).delegate(".product-number-reduce", 'click', function () {
    var now = $(this),
      _input = now.siblings(".js-quantity-selector");
    num = parseInt(_input.val()) - 1;
    if (_input.val() == 1) {
      return false;
    } else {
      _input.val(num);
    }
  })
  $(".slick-slider button").html("");
  //quick view
})
$(window).scroll(function () {
  var h = document.documentElement.scrollTop || document.body.scrollTop;
  // console.log(h * 0.25); //控制台查看监听滚动 
  var $headerTop = $('.header-main');
  if (h >= 10) {
    $headerTop.css({
      "background": "rgba(255,255,255,0" + h * 0.5 + ")",
      "box-shadow": "0px 10px 10px -10px rgba(204, 204, 204,0.7)"
    });
    // $back.css('background', "#fff").find('.iconfont').css('color', "#000");
  } else {
    if (h < 10) {
      $headerTop.css({
        "background": "rgba(255,255,255,0.0" + h * 0.25 + ")",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0,0)"
      });
    } else if (h >= 10 && h <= 10) {
      $headerTop.css('background', "rgba(255,255,255,0.0" + h * 0.25 + ")")
    }
  }
})